import {dateTime} from "services/date";
import {Zone} from "types/Zone";
import {transformOpeningHours} from "../../opening-hours";

/**
 * Transform the given zone by deserializing object properties
 *
 * @internal
 * @param zone
 */
export default function deserializeZone(zone: any): Zone {
    zone.created_at = dateTime(zone.created_at)
    zone.updated_at = dateTime(zone.updated_at)

    if (zone.hours) {
      zone.hours = transformOpeningHours(zone.hours);
    }

    return zone;
}